module.exports = __webpack_public_path__ + "img/collaborate_7.39115b66.jpg";